import { Col, Modal, Row } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { useEffect, useState } from "react";
import { toGetBranches } from "../../apis/actions/branches.actions";
import { useTranslation } from "react-i18next";
import BranchHours from "../branches/BranchHours";
import {
  pickLocalizedHours,
  resolveBranchWorkingHours,
} from "../../constants/branchWorkingHours";

type MapModalTarget = { mapUrl: string; name: string; branchKey: string | number };

const Blog1 = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { t, i18n } = useTranslation();
  const [mapTarget, setMapTarget] = useState<MapModalTarget | null>(null);
  const { list } = useSelector(
    (state: RootState) => state.branches.branchesHome
  );

  useEffect(() => {
    dispatch(toGetBranches(i18n.language));
  }, [dispatch, i18n.language]);

  return (
    <section className="section-box  background-body">
      <div className="container">
        <Row gutter={[20, 20]}>
          {list.map((el: any, i: any) => {
            const hours = pickLocalizedHours(
              resolveBranchWorkingHours(el),
              i18n.language
            );
            return (
              <Col
                xs={24}
                sm={12}
                md={8}
                lg={8}
                xl={8}
                xxl={8}
                key={el.id ?? i}
                className="ac-branch-col"
              >
                <div className="card-news background-card hover-up ac-branch-card">
                  <div className="ac-branch-card__content">
                    <div className="ac--branches-card-image-container">
                      <img src={el.image_1920} alt={el.name ?? ""} />
                    </div>
                    <div className="card-info">
                      <div className="card-meta ac--font-expo ac--color-primary">
                        <h6>{el.name}</h6>
                      </div>
                      <div className="card-title ac--font-expo ac--color-light-dark">
                        <div className="ac--font-expo">
                          {el.address.split("\n").map((line: any, index: any) => (
                            <p key={index}>{line}</p>
                          ))}
                        </div>
                      </div>
                      <BranchHours
                        days={hours.days}
                        start={hours.start}
                        end={hours.end}
                      />
                    </div>
                  </div>
                  {el.map_url ? (
                    <button
                      type="button"
                      className="ac-branch-card__map-trigger"
                      aria-haspopup="dialog"
                      aria-expanded={
                        !!mapTarget && mapTarget.branchKey === (el.id ?? i)
                      }
                      aria-label={t("branches.openMapAria", { name: el.name })}
                      onClick={() =>
                        setMapTarget({
                          mapUrl: el.map_url,
                          name: el.name,
                          branchKey: el.id ?? i,
                        })
                      }
                    >
                      <span className="ac-branch-card__map-overlay" aria-hidden>
                        <span className="ac-branch-card__map-overlay-inner">
                          <EnvironmentOutlined className="ac-branch-card__map-icon" />
                          <span className="ac-branch-card__map-hint">
                            {t("branches.mapHoverHint")}
                          </span>
                        </span>
                      </span>
                    </button>
                  ) : null}
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
      <Modal
        className="ac-branch-map-modal"
        open={!!mapTarget}
        title={
          mapTarget ? (
            <span className={i18n.language === "ar" ? "ac--font-expo" : undefined}>
              {mapTarget.name}
            </span>
          ) : null
        }
        okText={t("btn.location")}
        cancelText={t("services.close")}
        centered
        destroyOnClose
        onCancel={() => setMapTarget(null)}
        onOk={() => {
          if (mapTarget?.mapUrl) window.open(mapTarget.mapUrl, "_blank");
          setMapTarget(null);
        }}
      >
        <p
          className={`ac-branch-map-modal__lead ${
            i18n.language === "ar" ? "ac--font-expo" : ""
          }`}
        >
          {t("branches.mapModalLead")}
        </p>
      </Modal>
    </section>
  );
};

export default Blog1;
